export const app = {
  connectToYourWhatsappNumber: 'Connetti al tuo numero WhatsApp',
  connectYourWhatsappBotWithYourWhatsappNumber: 'Collega il tuo Bot WhatsApp al tuo numero WhatsApp',
  connect: 'Connetti',
};
